import {
  SupplierApiError,
  mapSupplierApiError,
  supplierGetAndParse,
  supplierPostAndParse,
  supplierPutAndParse,
} from './supplierApiCore';
import {
  regenerateSupplierPublicationSlugRequestV1Schema,
  supplierPublicationSettingsV1Schema,
  updateSupplierPublicationSettingsRequestV1Schema,
} from './supplierPublicationContracts';

// Authenticated, operator-facing management of the S8 Supplier Page/widget
// publication (`GET|PUT /supplier/publication`, `POST
// /supplier/publication/slug/regenerate` — src/api/freeSupplier/supplierPublication.ts).

export const SUPPLIER_PUBLICATION_ENDPOINTS = Object.freeze({
  settings: '/supplier/publication',
  regenerateSlug: '/supplier/publication/slug/regenerate',
});

export class SupplierPublicationApiError extends SupplierApiError {
  constructor(payload, httpStatus) {
    super(payload, httpStatus, 'Supplier publication request failed');
    this.name = 'SupplierPublicationApiError';
  }
}

const mapApiError = (error) => mapSupplierApiError(error, SupplierPublicationApiError);

export const fetchSupplierPublicationSettings = () =>
  supplierGetAndParse(
    SUPPLIER_PUBLICATION_ENDPOINTS.settings,
    supplierPublicationSettingsV1Schema,
    mapApiError,
  );

// `updateSupplierPublicationSettingsRequestV1Schema.parse` is run client-side
// before the request goes out so the superRefine (includeFutureRevisions
// required to enable) surfaces before a round trip.
export const updateSupplierPublicationSettings = (body) => {
  const request = updateSupplierPublicationSettingsRequestV1Schema.parse(body);
  return supplierPutAndParse(
    SUPPLIER_PUBLICATION_ENDPOINTS.settings,
    request,
    supplierPublicationSettingsV1Schema,
    mapApiError,
  );
};

export const regenerateSupplierPublicationSlug = () =>
  supplierPostAndParse(
    SUPPLIER_PUBLICATION_ENDPOINTS.regenerateSlug,
    regenerateSupplierPublicationSlugRequestV1Schema.parse({ version: 1 }),
    supplierPublicationSettingsV1Schema,
    mapApiError,
  );
